import { ToggleButton, Tooltip } from '@mui/material';
import useSelectedBlock from '../hooks/useSelectedBlock';
import useMark from '@hooks/useMark';

function BlockButton({ path, value, icon, tooltip, fallbackProperty }) {
    const { getProperty, setProperty } = useSelectedBlock();
    // const { getFallbackValue } = useMark();

    // const selected = [value, getFallbackValue(fallbackProperty)].includes(
    //     getProperty(path) || null,
    // );

    // console.log(selected);
    // console.log(value, getFallbackValue(fallbackProperty), getProperty(path));
    const selected = getProperty(path) === value;

    return (
        <Tooltip title={tooltip}>
            <ToggleButton
                selected={selected}
                value={value}
                onMouseDown={e => {
                    e.preventDefault();
                    setProperty(path, selected ? undefined : value);
                }}
            >
                {icon}
            </ToggleButton>
        </Tooltip>
    );
}

export default BlockButton;
